import { Slide } from '@act/storybook';
import { actingUserAppSelectors } from 'redux/redux';
import { useMobile } from '../../../../utilities/MobileContext';
import { WorkMetricsMobile } from './WorkMetrics/WorkMetricsMobile';
import { WorkMetricsDesktop } from './WorkMetrics/WorkMetricsDesktop';
import { UserReecapDto } from '@act/shared/data-transfer-objects';

export const WorkMetricsSlide = () => {
  const { isMobile } = useMobile();
  const actingUser = actingUserAppSelectors.useSelectActingUser();
  const guideName = actingUser?.firstName || 'GUIDE_NAME';
  const reecap = actingUser?.reecap as UserReecapDto;

  if (!reecap) {
    return null;
  }

  return (
    <Slide isVerticallyCentered={false}>
      {isMobile ? (
        // Mobile: Single scrollable container with paragraph and cards
        <WorkMetricsMobile guideName={guideName} reecap={reecap} />
      ) : (
        // Desktop: Separate text and grid layout
        <WorkMetricsDesktop guideName={guideName} reecap={reecap} />
      )}
    </Slide>
  );
};
